import { Directive, ElementRef, HostListener, Input } from '@angular/core';

// taken from https://gist.github.com/ahmeti/5ca97ec41f6a48ef699ee6606560d1f7

@Directive({
    selector: '[lib-range]',
    standalone: false
})
export class RangeDirective {
    @Input() minimum: number = null;
    @Input() maximum: number = null;

    constructor(private el: ElementRef) {}

    @HostListener('input', ['$event'])
    onInput(_event): void {
        const currentValue: string = this.el.nativeElement.value;

        if (this.maximum !== null && Number(currentValue) > Number(this.maximum)) {
            let result = Number(currentValue).toString().slice(0, this.maximum.toString().length);

            if (Number(result) > Number(this.maximum))
                result = result.slice(0, -1);

            this.el.nativeElement.value = result;
        }
    }

    @HostListener('blur', ['$event'])
    onBlur(_event): void {
        if (this.minimum !== null && Number(this.el.nativeElement.value) < Number(this.minimum))
            this.el.nativeElement.value = Number(this.minimum).toString();
    }
}
